import { useMatomo } from "@jonkoops/matomo-tracker-react";
import Button from "../../components/Button";

function Contact() {
    const { trackEvent } = useMatomo();

    const onNewsletterButtonClick = () => { 
        trackEvent({ category: 'contact', action: `newsletter button click` });
    }

    const onCallButtonClick = () => { 
        trackEvent({ category: 'contact', action: `call button click` });
    }
    
    return (
        <div className="max-w-screen-md box mx-auto my-32 max-lg:px-5">
            <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
                Don't miss any new information <br className="dont_ignore"/> on our product!
            </h1>
            <p className="font-medium text-slate-400 mb-10">
                Get the newest insights about the product, supported protocols and<br/>an update when the product is ready for beeing tested by you!
            </p>
            <div className="flex flex-row justify-between items-center max-md:flex-col">
                <form className="lg-w-1/2 sm:w-8/12 w-full">
                    <p className="text-left mb-2">
                        <label htmlFor="email" className="text-slate-500 font-medium text-sm">
                            Name
                        </label>
                    </p>
                    <input type="text" placeholder="Joe Doe" className="border border-slate-100 rounded-xl px-4 py-2 w-full mb-4" />

                    <p className="text-left mb-2">
                        <label htmlFor="email" className="text-slate-500 font-medium text-sm">
                            Company
                        </label>
                    </p>
                    <input type="text" placeholder="Company Ltd." className="border border-slate-100 rounded-xl px-4 py-2 w-full mb-4" />

                    <p className="text-left mb-2">
                        <label htmlFor="email" className="text-slate-500 font-medium text-sm">
                            Email
                        </label>
                    </p>
                    <input type="text" placeholder="joe.doe@example.com" typeof="email" className="border border-slate-100 rounded-xl px-4 py-2 w-full" />
                    <Button text="Join newsletter" color="primary" size="medium" className="w-full mx-0 my-4 h-[42px]" onClick={onNewsletterButtonClick}/>
                    <hr className="border-0.5 border-slate-100" />
                    <Button text="Book a call" color="secondary" size="medium" className="w-full mx-0 my-4 h-[42px]" onClick={onCallButtonClick}/>
                </form>
                <img src="/DEMO/images/map.png" alt="Map of Linz" className="lg:w-1/2 md:ml-4 sm:w-8/12 w-full" />
            </div>

        </div>
    )
}

export default Contact;